import { css } from 'twin.macro';
import { Trans } from 'react-i18next';

import { Layout } from '../components/Layout';
import { ForgotPasswordForm } from '@auth_module/components/ForgotPasswordForm';
import { withTitle } from '@hoc/withTitle';
import { Spacer } from '@components/Spacer';
import loginGraphic from '@assets/images/login-graphic.svg';

const backgroundImage = css`
  background-image: url(${loginGraphic});
`;

const ForgotPasswordFooter = () => {
  return (
    <>
      <Spacer direction='vertical' size='xl' />
      <p tw='text-text-and-icon-invert'>
        <Trans i18nKey='auth.forgot_password_form.go_back'>
          I remember my password -
          <a tw='text-accent-muted' href='/login'>
            go back to Login
          </a>
        </Trans>
      </p>
    </>
  );
};

const _ForgotPasswordPage = () => {
  return (
    <Layout
      tw='top-[25px] md:top-[calc(50% - 225px)] md:max-w-[447px] px-6 md:px-0'
      backgroundCss={backgroundImage}
      footer={<ForgotPasswordFooter />}>
      <ForgotPasswordForm />
    </Layout>
  );
};

export const ForgotPasswordPage = withTitle(_ForgotPasswordPage, 'auth.forgot_password_page.title');
